module.exports = __webpack_public_path__ + "img/icon-slider-arrow-prev.a5a0b03c.svg";